import GetValueDashboardForIndividualTypes from './GetValueDashboardForIndividual.types';

export const getValueDashboardForIndividualStart = (data: any) => ({
	type: GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_START,
	payload: data,
});

export const getValueDashboardForIndividualSuccess = (data: any) => ({
	type: GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_SUCCESS,
	payload: data,
});

export const getValueDashboardForIndividualFailure = (error: unknown) => ({
	type: GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_FAILURE,
	payload: error,
});

export const getValueDashboardForIndividualResponseChanged = () => ({
	type: GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_RESPONSE_CHANGED,
});

export const getValueDashboardForIndividualResponseRestStart = () => ({
	type: GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_RESPONSE_REST_START,
});
